import Axios from "../config/Axios";

// Obtener todas las áreas
export const ApiGetAllAreas = async () => {
  try {
    const result = await Axios.get(`/GETallAreas`);
    return result.data;
  } catch (e) {
    return {
      sms: "err",
      data: [],
      mensaje: e,
    };
  }
};

// Crear área
export const ApiCreateArea = async (data) => {
  try {
    const result = await Axios.post(`/POSTcreateArea`, data);
    return result.data;
  } catch (e) {
    return {
      sms: "err",
      data: [],
      mensaje: e,
    };
  }
};

// Editar área
export const ApiEditArea = async (data) => {
  try {
    const result = await Axios.post(`/POSTeditArea`, data);
    return result.data;
  } catch (e) {
    return {
      sms: "err",
      data: [],
      mensaje: e,
    };
  }
};

// Eliminar área
export const ApiDeleteArea = async (data) => {
  try {
    const result = await Axios.post(`/POSTdeleteArea`, data);
    return result.data;
  } catch (e) {
    return {
      sms: "err",
      data: [],
      mensaje: e,
    };
  }
};

// Procesar Excel de áreas
export const ApiProcessExcelAreas = async (formData) => {
  try {
    const result = await Axios.post(`/POSTprocessExcelAreas`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return result.data;
  } catch (e) {
    return {
      sms: "err",
      data: [],
      mensaje: e,
    };
  }
};